var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echarts",attrs:{"id":"bar-stacked"}},[_c('VueApexCharts',{attrs:{"type":"bar","options":_vm.options,"series":_vm.series,"height":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }